import DefaultLocations from
  'containers/DefaultLocations/themes/DefaultLocationsLight.css';
import DefaultLocationsTable from
  'containers/DefaultLocations/components/DefaultLocationsTable/themes/DefaultLocationsTableLight.css';
import DefaultLocationsTableFooter from
  'containers/DefaultLocations/components/DefaultLocationsTableFooter/themes/DefaultLocationsTableFooterLight.css';

export default {
  DefaultLocations,
  DefaultLocationsTable,
  DefaultLocationsTableFooter
};
